import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  Grid,
} from '@material-ui/core';
import { USER, } from 'constants/parkingTypes'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3)
  },
  formGroup: {
    marginBottom: theme.spacing(3)
  },
}));

const ParkingManagement = props => {
  const { className, parkingInfos, handleFieldChange, handleDelegateEmailChange, delegateEmail, isAdmin, ...rest } = props;

  const classes = useStyles();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Parking Management" />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item sm={12} md={6}>
            <div className={classes.formGroup}>
              <TextField
                fullWidth
                label="Notification Email"
                name="partnerEmail"
                onChange={event =>
                  handleFieldChange(event, 'partnerEmail', event.target.value)
                }
                value={parkingInfos.partnerEmail}
                variant="outlined"
                required
              />
            </div>
          </Grid>
          <Grid item sm={12} md={6}>
            <div className={classes.formGroup}>
              <TextField
                fullWidth
                label="Phone Number"
                name="phoneNumber"
                onChange={event =>
                  handleFieldChange(event, 'phoneNumber', event.target.value)
                }
                value={parkingInfos.phoneNumber || ''}
                variant="outlined"
                required
              />
            </div>
          </Grid>
        </Grid>
        {parkingInfos.type === USER && (
          <div className={classes.formGroup}>
            <TextField
              className={classes.field}
              fullWidth
              label="Automatically accept bookings"
              margin="dense"
              name="autoBooking"
              onChange={event => handleFieldChange(event, 'autoBooking', event.target.value)}
              select
              // eslint-disable-next-line react/jsx-sort-props
              SelectProps={{ native: true }}
              value={parkingInfos.autoBooking}
              variant="outlined"
            >
              <option disabled value=""/>
              <option value={true} label="Yes"></option>
              <option value={false} label="No"></option>
            </TextField>
          </div>
        )}
        {parkingInfos.type === USER && (
          <Grid item sm={12} md={12}>
            <div className={classes.formGroup}>
              <TextField
                fullWidth
                label="Delegate check-in to"
                name="delegateEmail"
                onChange={event =>
                  handleDelegateEmailChange(event.target.value)
                }
                value={delegateEmail || ''}
                variant="outlined"
              />
            </div>
          </Grid>
        )}
        <Grid container spacing={3}>
          <Grid item sm={12} md={6}>
            <div className={classes.formGroup}>
              <TextField
                fullWidth
                label="VAT"
                name="vat"
                onChange={event =>
                  handleFieldChange(event, 'vat', event.target.value)
                }
                value={parkingInfos.vat}
                variant="outlined"
                disabled={!isAdmin}
              />
            </div>
          </Grid>
          <Grid item sm={12} md={6}>
            <div className={classes.formGroup}>
              <TextField
                fullWidth
                label="Service Charge"
                name="serviceCharge"
                onChange={event =>
                  handleFieldChange(event, 'serviceCharge', event.target.value)
                }
                value={parkingInfos.serviceCharge}
                variant="outlined"
                disabled={!isAdmin}
              />
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

ParkingManagement.propTypes = {
  parkingInfos: PropTypes.object,
  handleFieldChange: PropTypes.func,
  handleDelegateEmailChange: PropTypes.func,
  delegateEmail: PropTypes.string,
  className: PropTypes.string,
};

export default ParkingManagement;
